export enum apiEndpoints {
  getRecruiter = '/api/admin/v1/recruiter_get-auth',
  getRecruiters = '/api/admin/v1/recruiter_get-list',
  getAgreements = '/api/admin/v1/agreement_get-list',
  getLegals = '/api/v1/legal_get-list',

  sendSms = '/api/v1/agreement_send-sms',
  signAgreement = '/api/v1/agreement_sign',
  previewAgreementTypeDocument = '/api/v1/agreement-type_preview-document',
}
